<!-- Item del calendario -->
<div class="relative item-container custom-center" *ngIf="eventos ? eventos.length > 0 : false; else d">
    <div class="item shadow-2 custom-center" style="flex-direction: column; justify-content: space-between;"
        [ngClass]="{'wth':hover, 'more-shadow': hover}" (mouseover)="hover = true" (mouseleave)="hover = false">
        <div style="width: 100%" class="text-end pr-2 pt-1">
            <p class="mb-1">{{day}}</p>
        </div>
        <ng-container *ngFor="let e of eventos; let i = index">
            <ng-container *ngIf="i < 2; else hoverSmall">
                <ng-container *ngIf="e.link; else noLink">
                    <small (click)="eventoClick(e)" class="text-item mb-1 custom-center justify-content-start"
                        style="background: {{e.color}}; color: white">
                        <i class="pi pi-info" *ngIf="isVencida(e.inicio)"
                            style="font-size: .8rem; color: red !important; transform: rotate(180deg)"></i>
                        {{e.titulo}}
                    </small>
                </ng-container>
                <ng-template #noLink>
                    <small (click)="eventoClick(e)" class="text-item mb-1 custom-center justify-content-start"><i
                            class="pi pi-circle-fill mr-1" style="font-size: .4rem; color: {{e.color}} !important"></i>
                        {{e.inicio | date: 'HH:mm'}} - {{e.titulo}}</small>
                </ng-template>
            </ng-container>
            <ng-template #hoverSmall>
                <small (click)="eventoClick(e)" [ngClass]="{'mostrar': hover}" class="oculto"
                    style="background: {{e.color}}; color: white">{{e.titulo}}</small>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="eventos.length > 2; else j">
            <small *ngIf="!hover" class="text-center">+ {{eventos.length - 2}} más</small>
        </ng-container>
        <ng-template #j>
            <small></small>
        </ng-template>

    </div>
</div>

<!-- En caso de no tener actividades -->
<ng-template #d>
    <div class="relative item-container custom-center">
        <div class="item shadow-2 custom-center" style="flex-direction: column; justify-content: space-between;">
            <div style="width: 100%" class="text-end pr-2 pt-1">
                <p class="mb-1">{{day}}</p>
            </div>
            <small class="absolute top-50 bottom-50">Sin actividad registrada</small>
        </div>
    </div>
</ng-template>